<template>
  <div class="data-list" :ref="list">
    <van-popup
      class="popup"
      v-model="showPopup"
      position="right"
      get-container="body"
      :lock-scroll="false"
      @click-overlay="$emit('close', false)"
      :close-on-click-overlay="false"
    >
      <div class="list-sticky" v-show="stickyTitle" :ref="sticky">
        {{ stickyTitle }}
      </div>
      <div
        v-if="anchorShow"
        class="list-anchor"
        @touchstart="touchStartAnchor"
        @touchmove.stop.prevent="touchMoveAnchor"
      >
        <ul>
          <li
            ref="anchor"
            v-for="(item, index) in dataList"
            class="item"
            :index="index"
            :class="{ current: currentIndex === index }"
            :key="index"
          >
            {{ item[dataset.key] }}
          </li>
        </ul>
      </div>
      <div class="scroll" :ref="scroll">
        <div class="list-content">
          <div
            :class="{ hot: hot && index === 0 }"
            v-for="(item, index) in dataList"
            :key="index"
            class="group"
            ref="group"
          >
            <div :index="item[dataset.key]" class="title">{{ item[dataset.key] }}</div>
            <div
              class="data-item"
              v-for="(item, bindex) in item[dataset.name]"
              :key="bindex"
              @click="$emit('selectItem', item)"
            >
              <img v-if="showLogo" :src="item.logo" alt class="ignore-logo" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Popup } from 'vant';
import BScroll from '@better-scroll/core';
export default {
  data() {
    return {
      bs: null,
      showPopup: false,
      currentIndex: 0,
      touch: {},
      scrollY: -1,
      anchorHeightList: [],
      dataset: {
        key: 'key',
        name: 'list',
      },
    };
  },
  computed: {
    stickyTitle() {
      if (this.scrollY > 0) {
        return '';
      }
      return this.dataList[this.currentIndex] ? this.dataList[this.currentIndex][this.dataset.key] : '';
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.dataset = { ...this.dataset, ...this.$refs.list.dataset };
    });
  },
  props: {
    list: {
      type: String,
      default: 'list',
    },
    sticky: {
      type: String,
      default: 'list',
    },
    scroll: {
      type: String,
      default: 'scroll',
    },
    showDataPopup: {
      type: Boolean,
      default: false,
    },
    showLogo: {
      type: Boolean,
      default: true,
    },
    hot: {
      type: Boolean,
      default: true,
    },
    anchorShow: {
      type: Boolean,
      default: true,
    },
    dataList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    showDataPopup(val) {
      this.showPopup = val;
      val && this.initScroll();
    },
    dataList: {
      handler() {
        setTimeout(() => {
          this.bs?.refresh();
          this.bs && this.calcHeight();
        });
      },
      immediate: true,
    },
    scrollY(val) {
      const anchorHeightList = this.anchorHeightList;
      if (val > 0) {
        this.currentIndex = 0;
        return;
      }
      for (let i = 0; i < anchorHeightList.length - 1; i++) {
        if (-val >= anchorHeightList[i] && -val < anchorHeightList[i + 1]) {
          this.currentIndex = i;
          return;
        }
      }
    },
  },
  methods: {
    initScroll() {
      this.$nextTick(() => {
        if (this.bs) {
          this.bs.refresh();
          return;
        }
        this.bs = new BScroll(this.$refs['scroll'], {
          scrollX: false,
          scrollY: true,
          click: true,
          probeType: 3,
        });
        this.dataList.length > 0 && this.calcHeight();
        this.bs.on('scroll', ({ y }) => {
          this.scrollY = y;
        });
      });
    },
    //开始滑动的点
    touchStartAnchor(event) {
      let anchorIndex = event.target.getAttribute('index');
      this.touch.y1 = event.touches[0].pageY;
      this.touch.anchorIndex = anchorIndex;
      this.scrollTo(anchorIndex);
    },
    //滑动到那个点
    touchMoveAnchor(event) {
      const anchorHeight = this.$refs.anchor[0].clientHeight || 18;
      this.touch.y2 = event.touches[0].pageY;
      let anchorIndex = (+this.touch.anchorIndex + (this.touch.y2 - this.touch.y1) / anchorHeight) | 0;
      this.scrollTo(anchorIndex);
    },
    scrollTo(index = 0) {
      if (index < 0) {
        index = 0;
      } else if (index > this.anchorHeightList.length - 2) {
        index = this.anchorHeightList.length - 2;
      }
      this.scrollY = -this.anchorHeightList[index];
      this.bs.scrollToElement(this.$refs.group[index], 0);
    },
    calcHeight() {
      this.anchorHeightList = [];
      const list = this.$refs.group || [];
      let height = 0;
      this.anchorHeightList.push(height);
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        height += item.clientHeight;
        this.anchorHeightList.push(height);
      }
    },
  },
  beforeDestroy() {
    this.bs?.destroyed?.();
    this.$emit('close', false);
  },
  components: {
    [Popup.name]: Popup,
  },
};
</script>
<style lang="scss" scoped>
.scroll {
  width: 600px;
  height: 100vh;
  overflow: hidden;
  position: relative;
  background: #fff;
}
.list-sticky {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  font-size: 30px;
  height: 70px;
  box-sizing: border-box;
  line-height: 70px;
  padding-left: 20px;
  color: #666666;
  background: #efefef;
}
.title {
  width: 100%;
  font-size: 30px;
  color: #323233;
  height: 70px;
  line-height: 70px;
  padding-left: 20px;
  background: #efefef;
}
.list-anchor {
  position: fixed;
  z-index: 300;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  padding: 20px 0;
  border-radius: 10px;
  font-size: 24px;
  text-align: center;
  font-family: Helvetica;
  .item {
    padding: 3px;
    line-height: 1;
    color: #666666;
    &.current {
      color: rgb(0, 60, 255);
    }
  }
}
.list-content {
  position: relative;
  width: 100%;
  .data-item:last-child {
    border: 0;
  }
  .data-item {
    align-items: center;
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 90%;
    margin: 0 auto;
    height: 70px;
    overflow: hidden;
    color: #1f2c60;
    background-color: #fff;
    border-bottom: 1px solid #ccc;
    .ignore-logo {
      width: 30px;
      margin: 0 8px 0 6px;
    }
  }
}
.hot {
  overflow: hidden;
  .data-item {
    flex-direction: column;
    justify-content: center;
    white-space: nowrap;
    display: flex;
    align-items: center;
    width: 20%;
    height: 120px;
    border: 0;
    float: left;
    span {
      margin-top: 4px;
      margin-bottom: 10px;
    }
  }
}
</style>
